import $ from '/js/header/jquery.js';
import { ListViewHelper } from "/js/tools/common-board/ListViewHelper";
const listViewHelper = new ListViewHelper();

$(() => {
    loadPage($("#pageNo").val());

    (function (window) {
        if (!window.history.enabled) {
            return false;
        }
        window.history.pushState({section: 1, page_index: 1}, "두인옥션", "?page=1");
        window.history.Adapter.bind(window, 'statechange', function () {
            //페이지 선택시 실행
            var State = window.history.getState();
            if (listViewHelper.manualChange) return false;
            loadPage(State.data['page_index']);
        });
    })(window);
    $(".tab_menu ul li:first").addClass("on");
    $(".tab_menu ul li").click(function () {
        $("#id_code").val($(this).data('code'));
        $("#txtSrch").val("");
        $("#pageNo").val(1);
        $("#srch_type option:eq(0)").prop("selected", true);
        $(".tab_menu ul li").removeClass("on");
        $(this).addClass("on");
        list();
    });
    $("#btnSrch").click(function () {
        $("#pageNo").val(1);
        list();
    });
    
    // 엔터키
    $(document).on('keypress', '#txtSrch', function (e) {
        if (e.which == 13) {
            $("#pageNo").val(1);
            list();
        }
    });
});

function list() {
    let arr_body = [];
    $.ajax({
        type: "POST",
        url: "/study/res/Study.php",
        data: $("#fmSrch").serialize(),
        dataType: "JSON",
        success: function (data) {
            if (data.totCnt > 0) {
                $.each(data.items, function () {
                    arr_body.push("<tr><td>");
                    arr_body.push(`<div class='bold' style='padding:10px;font-size:15px'>${this.title}</div>`);
                    arr_body.push(`<div style='padding:15px 25px;line-height:22px;font-weight:300'>${this.content}</div>`);
                    arr_body.push("</td></tr>");
                });
                $("#paging").show();
                $("#paging").html(listViewHelper.paging(data.totCnt, $("#pageNo").val(), loadPage, $("#dataSize").val(), $("#pageSize").val()));
                window.history.pushState({
                    section: 1,
                    page_index: $("#pageNo").val()
                }, "두인옥션", `?page=${$("#pageNo").val()}`);
                listViewHelper.manualChange = false;
            } else {
                $("#paging").hide();
                $("#ltTbody").html("");
                arr_body.push("<tr style='line-height:200px'><td class='center f14'>검색 결과가 없습니다.</td></tr>");
            }
            $("#ltTbody").html(arr_body.join(""));
            listViewHelper.formSrchStyle(fmSrch);
        }
    });
}

function loadPage(v) {
    $("#pageNo").val(v);
    list();
}